import React, {Fragment, useRef} from "react";
import { Link , NavLink} from "react-router-dom";
import {Skeleton} from "@mui/material";
import LazyLoad from "react-lazy-load";
import Grid from '@mui/material/Grid';
import customerimage from '../../../assets/images/customerimage.png';
const Home_Section_J = (props) => {
    return (


        <Fragment>


            <div className={"home-sec-j"} style={{"backgroundColor":"#01A3D4"}} >

                <div className={"container_bk_fronts"}>

                    <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>


                        <Grid item lg={3} md={3} sm={12} xs={12}>
                            <div className={"card-counter-home"}>
                            <span className={"card-counter-home-number"}>+1000</span>
                            <span className={"card-counter-home-text"}>خریدار</span>
                            </div>
                        </Grid>


                        <Grid item lg={3} md={3} sm={12} xs={12}>
                            <div className={"card-counter-home"}>
                                <span className={"card-counter-home-number"}>+1000</span>
                                <span className={"card-counter-home-text"}>تامین کننده</span>
                            </div>
                        </Grid>


                        <Grid item lg={3} md={3} sm={12} xs={12}>
                            <div className={"card-counter-home"}>
                                <span className={"card-counter-home-number"}>+1000</span>
                                <span className={"card-counter-home-text"}>خریدار</span>
                            </div>
                        </Grid>

                        <Grid item lg={3} md={3} sm={12} xs={12}>
                            <div className={"card-counter-home"}>
                                <span className={"card-counter-home-number"}>+1000</span>
                                <span className={"card-counter-home-text"}>تامین کننده</span>
                            </div>
                        </Grid>



                    </Grid>
                </div>


            </div>


        </Fragment>
    );
}

export default Home_Section_J;